// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3DGrg","header":"MergedInvoice_header__280gL"};